import { Navigate, generatePath } from 'react-router-dom';

import { useTypedParams } from '@sorare/routing';

import { So5LeaderboardSeasonality } from '@sorare/core/src/__generated__/globalTypes';
import { FOOTBALL_PLAY_PRO_FIXTURE_ENTER_SEASONALITY } from '@sorare/core/src/constants/__generated__/routes';

import { PageParams } from './__generated__/routeParams';

const FixtureEnterPage = () => {
  const { fixture } = useTypedParams<PageParams>();

  return (
    <Navigate
      replace
      to={generatePath(FOOTBALL_PLAY_PRO_FIXTURE_ENTER_SEASONALITY, {
        fixture,
        seasonality: So5LeaderboardSeasonality.IN_SEASON.toLowerCase(),
      })}
    />
  );
};
export default FixtureEnterPage;
